<template>
  <div>
    <router-view :key="$route.query" />
  </div>
</template>

<script>
  window.teasersColor = {};

    export default {
      created(){
//           this.Helper.events.subscribe('EVENT_LOAD_TEASERS', (data) => {
//               let i = 0;
//               document.querySelectorAll('[itemprop="name"]').forEach(function (element){
//                       i++;
//                       if (i % 3 === 0) element.classList.add("zip");
//                   }
//               );
//           });
      }

    }
</script>